(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4621],{

/***/ 14094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68777);

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "container__Container",
  componentId: "sc-1cmdyws-0"
})(["width:100%;", ""], function (_ref) {
  var size = _ref.size;

  switch (size) {
    case 'lg':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:1560px;padding:0 20px;"]);

    case 'md':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:1280px;padding:0 20px;"]);

    case 'sm':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:1064px;padding:0 20px;"]);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["max-width:2000px;padding:0 20px;"]);
  }
});

/***/ }),

/***/ 6035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; },
/* harmony export */   "w": function() { return /* binding */ PageLoader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68777);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function Loader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "lds-roller",
    "data-testid": "loader",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})]
  });
}
function PageLoader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageLoaderWrapper, {
    "data-testid": "pageloader",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Loader, {})
  });
}
var PageLoaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "loader__PageLoaderWrapper",
  componentId: "sc-tkf924-0"
})(["position:fixed;z-index:999;top:0;left:0;width:100%;height:100%;background-color:rgba(255,255,255,0.8);display:flex;align-items:center;justify-content:center;"]);

/***/ }),

/***/ 96861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68777);

var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "text__Text",
  componentId: "sc-1bgtwf9-0"
})(["text-transform:", ";text-decoration:", ";color:", ";", " ", ""], function (props) {
  return props.textTransform;
}, function (props) {
  return props.textDecoration;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackPallet1;
}, function (_ref2) {
  var fw = _ref2.fw;

  switch (fw) {
    case 'light':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Light;"]);

    case 'medium':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Medium;"]);

    case 'bold':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Bold;"]);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Regular;"]);
  }
}, function (props) {
  switch (props.type) {
    case 'mode1':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode1.fontSize, props.theme.typography.texts.mode1.lineHeight);

    case 'mode2':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode2.fontSize, props.theme.typography.texts.mode2.lineHeight);

    case 'mode3':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode3.fontSize, props.theme.typography.texts.mode3.lineHeight);

    case 'mode4':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode4.fontSize, props.theme.typography.texts.mode4.lineHeight);

    case 'mode5':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode5.fontSize, props.theme.typography.texts.mode5.lineHeight);

    case 'mode6':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode6.fontSize, props.theme.typography.texts.mode6.lineHeight);

    case 'mode7':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode7.fontSize, props.theme.typography.texts.mode7.lineHeight);

    case 'mode8':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode8.fontSize, props.theme.typography.texts.mode8.lineHeight);

    case 'mode9':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode9.fontSize, props.theme.typography.texts.mode9.lineHeight);

    case 'mode10':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode10.fontSize, props.theme.typography.texts.mode10.lineHeight);

    case 'mode11':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts.mode11.fontSize, props.theme.typography.texts.mode11.lineHeight);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.texts["default"].fontSize, props.theme.typography.texts["default"].lineHeight);
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);

/***/ }),

/***/ 51951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68777);

var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "title__Title",
  componentId: "sc-13oetwq-0"
})(["letter-spacing:-0.5px;color:", ";text-transform:", ";text-decoration:", ";", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackPallet1;
}, function (props) {
  return props.textTransform;
}, function (props) {
  return props.textDecoration;
}, function (_ref2) {
  var fw = _ref2.fw;

  switch (fw) {
    case 'light':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Light;"]);

    case 'medium':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Medium;"]);

    case 'bold':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Bold;"]);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-family:Walsheim-Regular;"]);
  }
}, function (props) {
  switch (props.type) {
    case 'mode1':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode1.fontSize, props.theme.typography.titles.mode1.lineHeight);

    case 'mode2':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode2.fontSize, props.theme.typography.titles.mode2.lineHeight);

    case 'mode3':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode3.fontSize, props.theme.typography.titles.mode3.lineHeight);

    case 'mode4':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode4.fontSize, props.theme.typography.titles.mode4.lineHeight);

    case 'mode5':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode5.fontSize, props.theme.typography.titles.mode5.lineHeight);

    case 'mode6':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode6.fontSize, props.theme.typography.titles.mode6.lineHeight);

    case 'mode7':
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles.mode7.fontSize, props.theme.typography.titles.mode7.lineHeight);

    default:
      return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["font-size:", ";line-height:", ";"], props.theme.typography.titles["default"].fontSize, props.theme.typography.titles["default"].lineHeight);
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Title);

/***/ }),

/***/ 84621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@tawk.to/tawk-messenger-react/dist/tawk-messenger-react.es.js

var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
const isValidString = (value) => {
  if (!value || value.length === 0) {
    return false;
  }
  return value !== null && value !== void 0 && typeof value === "string";
};
const loadScript = ({ propertyId = "", widgetId = "", embedId = "", basePath = "tawk.to" }) => {
  if (embedId.length) {
    if (!document.getElementById(embedId)) {
      const element = document.createElement("div");
      element.id = embedId;
      document.body.appendChild(element);
    }
    window.Tawk_API.embedded = embedId;
  }
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://embed.${basePath}/${propertyId}/${widgetId}`;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);
};
const TawkMessenger = (0,react.forwardRef)((props, ref) => {
  (0,react.useEffect)(() => {
    load();
  }, []);
  const load = () => {
    if (!isValidString(props.propertyId)) {
      console.error("[Tawk-messenger-react warn]: You didn't specified 'propertyId' property in the plugin.");
      return;
    }
    if (!isValidString(props.widgetId)) {
      console.error("[Tawk-messenger-react warn]: You didn't specified 'widgetId' property in the plugin.");
      return;
    }
    if (!window || !document) {
      return;
    }
    init();
  };
  const init = () => {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    loadScript({
      propertyId: props.propertyId,
      widgetId: props.widgetId,
      embedId: props.embedId,
      basePath: props.basePath
    });
    if (props.customStyle && typeof props.customStyle === "object") {
      window.Tawk_API.customStyle = props.customStyle;
    }
    mapCallbacks();
  };
  (0,react.useImperativeHandle)(ref, () => ({
    maximize: () => {
      return window.Tawk_API.maximize();
    },
    minimize: () => {
      return window.Tawk_API.minimize();
    },
    toggle: () => {
      return window.Tawk_API.toggle();
    },
    popup: () => {
      return window.Tawk_API.popup();
    },
    showWidget: () => {
      return window.Tawk_API.showWidget();
    },
    hideWidget: () => {
      return window.Tawk_API.hideWidget();
    },
    toggleVisibility: () => {
      return window.Tawk_API.toggleVisibility();
    },
    endChat: () => {
      return window.Tawk_API.endChat();
    },
    getWindowType: () => {
      return window.Tawk_API.getWindowType();
    },
    getStatus: () => {
      return window.Tawk_API.getStatus();
    },
    isChatMaximized: () => {
      return window.Tawk_API.isChatMaximized();
    },
    isChatMinimized: () => {
      return window.Tawk_API.isChatMinimized();
    },
    isChatHidden: () => {
      return window.Tawk_API.isChatHidden();
    },
    isChatOngoing: () => {
      return window.Tawk_API.isChatOngoing();
    },
    isVisitorEngaged: () => {
      return window.Tawk_API.isVisitorEngaged();
    },
    onLoaded: () => {
      return window.Tawk_API.onLoaded;
    },
    onBeforeLoaded: () => {
      return window.Tawk_API.onBeforeLoaded;
    },
    widgetPosition: () => {
      return window.Tawk_API.widgetPosition();
    },
    visitor: (data) => {
      window.Tawk_API.visitor = data;
    },
    setAttributes: (attribute, callback) => {
      window.Tawk_API.setAttributes(attribute, callback);
    },
    addEvent: (event, metadata, callback) => {
      window.Tawk_API.addEvent(event, metadata, callback);
    },
    addTags: (tags, callback) => {
      window.Tawk_API.addTags(tags, callback);
    },
    removeTags: (tags, callback) => {
      window.Tawk_API.removeTags(tags, callback);
    }
  }));
  const mapCallbacks = () => {
    window.addEventListener("tawkLoad", () => {
      props.onLoad();
    });
    window.addEventListener("tawkStatusChange", (status) => {
      props.onStatusChange(status.detail);
    });
    window.addEventListener("tawkBeforeLoad", () => {
      props.onBeforeLoad();
    });
    window.addEventListener("tawkChatMaximized", () => {
      props.onChatMaximized();
    });
    window.addEventListener("tawkChatMinimized", () => {
      props.onChatMinimized();
    });
    window.addEventListener("tawkChatHidden", () => {
      props.onChatHidden();
    });
    window.addEventListener("tawkChatStarted", () => {
      props.onChatStarted();
    });
    window.addEventListener("tawkChatEnded", () => {
      props.onChatEnded();
    });
    window.addEventListener("tawkPrechatSubmit", (data) => {
      props.onPrechatSubmit(data.detail);
    });
    window.addEventListener("tawkOfflineSubmit", (data) => {
      props.onOfflineSubmit(data.detail);
    });
    window.addEventListener("tawkChatMessageVisitor", (message) => {
      props.onChatMessageVisitor(message.detail);
    });
    window.addEventListener("tawkChatMessageAgent", (message) => {
      props.onChatMessageAgent(message.detail);
    });
    window.addEventListener("tawkChatMessageSystem", (message) => {
      props.onChatMessageSystem(message.detail);
    });
    window.addEventListener("tawkAgentJoinChat", (data) => {
      props.onAgentJoinChat(data.detail);
    });
    window.addEventListener("tawkAgentLeaveChat", (data) => {
      props.onAgentLeaveChat(data.detail);
    });
    window.addEventListener("tawkChatSatisfaction", (satisfaction) => {
      props.onChatSatisfaction(satisfaction.detail);
    });
    window.addEventListener("tawkVisitorNameChanged", (visitorName) => {
      props.onVisitorNameChanged(visitorName.detail);
    });
    window.addEventListener("tawkFileUpload", (link) => {
      props.onFileUpload(link.detail);
    });
    window.addEventListener("tawkTagsUpdated", (data) => {
      props.onTagsUpdated(data.detail);
    });
    window.addEventListener("tawkUnreadCountChanged", (data) => {
      props.onUnreadCountChanged(data.detail);
    });
  };
  return null;
});
TawkMessenger.displayName = "TawkMessenger";
TawkMessenger.defaultProps = {
  customStyle: null,
  embedId: "",
  basePath: "tawk.to",
  onLoad: () => {
  },
  onStatusChange: () => {
  },
  onBeforeLoad: () => {
  },
  onChatMaximized: () => {
  },
  onChatMinimized: () => {
  },
  onChatHidden: () => {
  },
  onChatStarted: () => {
  },
  onChatEnded: () => {
  },
  onPrechatSubmit: () => {
  },
  onOfflineSubmit: () => {
  },
  onChatMessageVisitor: () => {
  },
  onChatMessageAgent: () => {
  },
  onChatMessageSystem: () => {
  },
  onAgentJoinChat: () => {
  },
  onAgentLeaveChat: () => {
  },
  onChatSatisfaction: () => {
  },
  onVisitorNameChanged: () => {
  },
  onFileUpload: () => {
  },
  onTagsUpdated: () => {
  },
  onUnreadCountChanged: () => {
  }
};
TawkMessenger.propTypes = {
  propertyId: PropTypes.string.isRequired,
  widgetId: PropTypes.string.isRequired,
  customStyle: PropTypes.object,
  embedId: PropTypes.string,
  basePath: PropTypes.string,
  onLoad: PropTypes.func,
  onStatusChange: PropTypes.func,
  onBeforeLoad: PropTypes.func,
  onChatMaximized: PropTypes.func,
  onChatMinimized: PropTypes.func,
  onChatHidden: PropTypes.func,
  onChatStarted: PropTypes.func,
  onChatEnded: PropTypes.func,
  onPrechatSubmit: PropTypes.func,
  onOfflineSubmit: PropTypes.func,
  onChatMessageVisitor: PropTypes.func,
  onChatMessageAgent: PropTypes.func,
  onChatMessageSystem: PropTypes.func,
  onAgentJoinChat: PropTypes.func,
  onAgentLeaveChat: PropTypes.func,
  onChatSatisfaction: PropTypes.func,
  onVisitorNameChanged: PropTypes.func,
  onFileUpload: PropTypes.func,
  onTagsUpdated: PropTypes.func,
  onUnreadCountChanged: PropTypes.func
};


// EXTERNAL MODULE: ./components/common/container/index.tsx
var container = __webpack_require__(14094);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./styles/breakpoints.ts
var breakpoints = __webpack_require__(20881);
;// CONCATENATED MODULE: ./components/header/styles.ts


var HeaderWrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "styles__HeaderWrapper",
  componentId: "sc-oh3d4t-0"
})(["position:fixed;z-index:910;top:0;left:0;width:100%;height:108px;display:flex;justify-content:center;transition:300ms all ease;> div{display:flex;justify-content:space-between;align-items:center;transition:200ms all ease;&:first-child{padding:0 80px;}}", " @media ", "{> div{&:first-child{padding:0 20px;}}}@media ", "{height:65px;}", ""], function (_ref) {
  var whiteHeader = _ref.whiteHeader,
      theme = _ref.theme;
  return whiteHeader && (0,styled_components_browser_esm/* css */.iv)(["background-color:rgba(255,255,255,0.9);backdrop-filter:blur(12px);.header-phone > p,.header-nav p,.account-logout > p{color:", " !important;}"], theme.colors.bluePallet1);
}, breakpoints/* device.laptop */.U.laptop, breakpoints/* device.tablet */.U.tablet, function (_ref2) {
  var transparentHeader = _ref2.transparentHeader,
      theme = _ref2.theme;
  return transparentHeader && (0,styled_components_browser_esm/* css */.iv)([".header-phone > p,.header-nav p,.account-logout > p{color:", " !important;}"], theme.colors.bluePallet1);
});
var HeaderLogo = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styles__HeaderLogo",
  componentId: "sc-oh3d4t-1"
})(["display:flex;flex-shrink:0;"]);
var HeaderNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styles__HeaderNav",
  componentId: "sc-oh3d4t-2"
})(["display:flex;flex-grow:1;margin-left:80px;margin-right:20px;gap:48px;> a{margin:0 12px;> p{color:", ";}}@media ", "{display:none;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, breakpoints/* device.laptop */.U.laptop);
var HeaderActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__HeaderActions",
  componentId: "sc-oh3d4t-3"
})(["display:flex;align-items:center;gap:20px;.header{&-valuation{flex-shrink:0;width:252px;height:48px;display:flex;align-items:center;justify-content:center;padding:12px 16px;border-radius:60px;background-color:", ";> p{color:", ";}&-mobile{display:flex;padding:10px;}}&-login{flex-shrink:0;display:flex;padding:12px 16px;width:78px;height:48px;border-radius:60px;background-color:", ";> p{color:", ";}}&-phone{flex-shrink:0;display:flex;margin-right:65px;> p{color:", ";text-decoration:underline;}}&-burger{display:flex;width:32px;height:32px;cursor:pointer;background-color:transparent;}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.bluePallet1;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.green;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.bluePallet1;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
});
var HeaderNavigationMobileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__HeaderNavigationMobileWrapper",
  componentId: "sc-oh3d4t-4"
})([".mobile-menu{height:100vh;position:absolute;z-index:999;top:0;left:0;width:100%;background-color:", ";display:flex;flex-direction:column;&-close{display:flex;justify-content:flex-end;align-items:center;height:108px;padding:0 20px;transition:200ms all ease;> button{width:32px;height:32px;display:flex;cursor:pointer;background-color:transparent;}}&-logo{margin-top:40px;margin-bottom:40px;display:flex;justify-content:center;}&-content{flex-grow:1;display:flex;flex-direction:column;justify-content:space-between;}&-list{display:flex;flex-direction:column;gap:28px;> li{display:flex;justify-content:center;> a{display:flex;position:relative;&:after{display:none;content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);width:66px;height:11px;background-image:url('/static/icons/vectors/vector-1.svg');background-repeat:no-repeat;}&.active::after{display:block;}> p{color:", ";}}}}&-phone{> p{color:", ";text-decoration:underline;text-align:center;}}&-actions{padding-bottom:80px;display:flex;align-items:center;justify-content:center;gap:20px;&-login{flex-shrink:0;display:flex;padding:12px 16px;width:78px;height:48px;border-radius:60px;background-color:", ";> p{color:", ";}}&-valuation{display:flex;background:", ";padding:12px 16px;border-radius:60px;width:252px;height:48px;}&-logout{display:flex;background-color:transparent;cursor:pointer;padding:0 16px;> p{color:", ";}}}}@media ", "{.mobile-menu{&-close{height:65px;}&-actions{flex-direction:column;}}}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.bluePallet3;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.white;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.white;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.green;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.bluePallet1;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.bluePallet5;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.white;
}, breakpoints/* device.tablet */.U.tablet);
var HeaderAccountWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__HeaderAccountWrapper",
  componentId: "sc-oh3d4t-5"
})(["cursor:pointer;display:flex;align-items:center;position:relative;z-index:2;flex-shrink:0;.account{&-avatar{width:42px;height:42px;display:flex;justify-content:center;align-items:center;background-color:", ";margin-right:12px;border-radius:50%;> p{color:", ";}}&-logout{display:flex;> p{color:", ";}}&-info{display:flex;> p{color:", ";margin-right:4px;}}&-dropdown{position:absolute;z-index:3;width:190px;top:calc(100% + 12px);right:0;background-color:", ";border:1px solid ", ";border-radius:8px;padding:6px 16px;&-item{padding:12px 0;display:flex;align-items:center;> p{margin-left:8px;}}}}@media ", "{.account{&-avatar{margin-right:0;}&-logout{display:none;}&-dropdown{left:auto;right:-8px;}}}@media ", "{margin-left:22px;.account{&-avatar{width:30px;height:30px;> p{font-size:14px;}}}}@media ", "{.account{&-avatar{margin-right:6px;}&-info{> p{display:none;}}}}"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.white;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.green;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.white;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.white;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.white;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.green;
}, breakpoints/* device.laptop */.U.laptop, breakpoints/* device.tablet */.U.tablet, breakpoints/* device.mobile */.U.mobile);
var HeaderBottomBlockWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__HeaderBottomBlockWrapper",
  componentId: "sc-oh3d4t-6"
})(["position:fixed;z-index:910;bottom:0;left:0;width:100%;height:65px;display:flex;justify-content:center;align-items:center;padding:12px;background-color:", ";transition:300ms all ease;> a{display:flex;gap:12px;> p{color:", ";}}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.bluePallet3;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.white;
});
// EXTERNAL MODULE: ./components/common/text/index.tsx
var common_text = __webpack_require__(96861);
// EXTERNAL MODULE: ./hooks/useWindow.ts
var useWindow = __webpack_require__(1284);
// EXTERNAL MODULE: ./constants/links.ts
var links = __webpack_require__(97449);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/header/HeaderNavigation.tsx








function HeaderNavigation() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderNav, {
    className: "header-nav",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: links/* MANIFESTO_LINK */.ar,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          children: "Manifesto"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: links/* BLOG_LINK */.rI,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        target: "_blank",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          children: "Blog"
        })
      })
    })]
  });
}

/* harmony default export */ var header_HeaderNavigation = (/*#__PURE__*/(0,react.memo)(HeaderNavigation));
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 183 modules
var motion = __webpack_require__(12451);
// EXTERNAL MODULE: ./hooks/useRedux.ts
var useRedux = __webpack_require__(22152);
// EXTERNAL MODULE: ./styles/animations.ts
var animations = __webpack_require__(54610);
// EXTERNAL MODULE: ./store/slices/global/index.ts + 1 modules
var global = __webpack_require__(70620);
// EXTERNAL MODULE: ./hooks/useLogout.ts
var useLogout = __webpack_require__(29623);
// EXTERNAL MODULE: ./constants/routes.ts
var routes = __webpack_require__(71624);
;// CONCATENATED MODULE: ./store/slices/global/selector.ts
var globalSelector = function globalSelector(state) {
  return state.globalSlice;
};
// EXTERNAL MODULE: ./store/slices/auth/selector.ts
var selector = __webpack_require__(89537);
// EXTERNAL MODULE: ./hooks/useTriggerFunnelyticsEvent/index.ts
var useTriggerFunnelyticsEvent = __webpack_require__(91974);
// EXTERNAL MODULE: ./hooks/useTriggerFunnelyticsEvent/constants.ts
var constants = __webpack_require__(16300);
;// CONCATENATED MODULE: ./components/header/HeaderNavigationMobile.tsx



















function HeaderNavigationMobile() {
  var _useLogout = (0,useLogout/* useLogout */.a)(),
      logout = _useLogout.logout;

  var _useTriggerFunnelytic = (0,useTriggerFunnelyticsEvent/* default */.Z)(),
      createEventTriggerer = _useTriggerFunnelytic.createEventTriggerer;

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(globalSelector),
      isOpenMobileNav = _useAppSelector.isOpenMobileNav;

  var _useAppSelector2 = (0,useRedux/* useAppSelector */.C)(selector/* userSelector */.n),
      jwt = _useAppSelector2.jwt;

  var dispatch = (0,useRedux/* useAppDispatch */.T)();
  var closeMobileMenu = (0,react.useCallback)(function () {
    dispatch((0,global.toggleMobileNav)());
  }, [dispatch]);
  var onLogout = (0,react.useCallback)(function () {
    closeMobileMenu();
    logout();
  }, [logout, closeMobileMenu]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderNavigationMobileWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: isOpenMobileNav && /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
        variants: animations/* fade */.U1,
        initial: "hidden",
        animate: "visible",
        exit: "exit",
        className: "mobile-menu",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mobile-menu-close",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: closeMobileMenu,
            className: "header-burger",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/static/icons/close.svg",
              width: 32,
              height: 32,
              alt: "Close Icon"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mobile-menu-logo",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/static/logo-richr-new.svg",
            width: 142,
            height: 48,
            priority: true,
            quality: 100
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mobile-menu-content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "mobile-menu-list",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: links/* MANIFESTO_LINK */.ar,
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  target: "_blank",
                  onClick: closeMobileMenu,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                    type: "mode10",
                    children: "Manifesto"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: links/* BLOG_LINK */.rI,
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  target: "_blank",
                  onClick: closeMobileMenu,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                    type: "mode10",
                    children: "Blog"
                  })
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "tel:+18449574247",
            className: "mobile-menu-phone",
            onClick: createEventTriggerer({
              eventName: constants/* GENERIC_EVENTS.CALL_EXPERT */._A.CALL_EXPERT,
              withPathname: true,
              ctaPosition: 'mobile-nav-bar'
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
              fw: "medium",
              type: "mode9",
              children: "+1844-957-4247"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mobile-menu-actions",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: routes/* HOME_VALUATION_ROUTE */.S0,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "mobile-menu-actions-valuation",
                onClick: createEventTriggerer({
                  eventName: constants/* HOME_VALUATION_EVENTS.START */.eM.START,
                  withPathname: true,
                  ctaPosition: 'mobile-nav-bar'
                }),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  fw: "bold",
                  children: "Get My Free Home Valuation"
                })
              })
            }), jwt && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              className: "mobile-menu-actions-logout",
              onClick: onLogout,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                fw: "bold",
                children: "Log out"
              })
            })]
          })]
        })]
      })
    })
  });
}

/* harmony default export */ var header_HeaderNavigationMobile = (/*#__PURE__*/(0,react.memo)(HeaderNavigationMobile));
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/verify-email/styles.ts


var VerifyEmailWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__VerifyEmailWrapper",
  componentId: "sc-1hsszy1-0"
})(["min-height:100vh;background-color:", ";overflow-x:hidden;position:fixed;top:0;left:0;width:100%;z-index:999;.verify-header{display:flex;justify-content:center;> div{transition:all 0.3s ease;margin:40px 20px;display:flex;justify-content:space-between;align-items:center;}&-logo{cursor:pointer;display:flex !important;}&-logo-mobile{cursor:pointer;display:none !important;}}@media ", "{.verify-header{> div{margin:20px 10px;}&-logo{display:none !important;}&-logo-mobile{display:flex !important;}&-actions{> p{display:none;}}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blue;
}, breakpoints/* device.tablet */.U.tablet);
var VerifyEmailBoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__VerifyEmailBoxWrapper",
  componentId: "sc-1hsszy1-1"
})(["display:flex;justify-content:center;.verify{width:100%;max-width:688px;background-color:", ";padding:64px 30px 48px;display:flex;flex-direction:column;align-items:center;text-align:center;transition:all 0.3s ease;@media ", "{max-width:100%;padding:48px 32px;min-height:calc(100vh - 65px);margin-bottom:0;}p{color:", ";}&-title{margin-top:36px;margin-bottom:24px;white-space:initial;max-width:492px;width:100%;> span{font-family:Walsheim-Bold;}@media ", "{font-size:28px;line-height:36px;}}&-desc{margin:24px 0;&-1,&-2{white-space:normal;}&-1{> span{font-family:Walsheim-Bold;}}&-resend{background-color:transparent;cursor:pointer;> p{color:", ";&:hover{text-decoration:underline;}}}}&-bottom{font-family:Walsheim-Bold;> a{color:", ";&:hover{text-decoration:underline;}}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, breakpoints/* device.tablet */.U.tablet, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.bluePallet1;
}, breakpoints/* device.tablet */.U.tablet, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.green;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.green;
});
var VerifyEmailError = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__VerifyEmailError",
  componentId: "sc-1hsszy1-2"
})(["color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.red;
});
// EXTERNAL MODULE: ./components/common/title/index.tsx
var title = __webpack_require__(51951);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./lib/axios.ts
var axios = __webpack_require__(5272);
;// CONCATENATED MODULE: ./lib/mutation/resend-email/hook.ts


var useResendEmail = function useResendEmail() {
  var _useMutation = (0,useMutation/* useMutation */.D)(function (args) {
    return axios/* api.post */.h.post('/auth/resend_mail_with_validation', args).then(function (res) {
      return res.data;
    });
  }),
      isError = _useMutation.isError,
      isLoading = _useMutation.isLoading,
      data = _useMutation.data,
      mutateAsync = _useMutation.mutateAsync,
      error = _useMutation.error;

  return {
    resend: mutateAsync,
    isError: isError,
    isLoading: isLoading,
    data: data,
    error: error
  };
};
;// CONCATENATED MODULE: ./lib/mutation/resend-email/index.ts


// EXTERNAL MODULE: ./components/common/loader/index.tsx
var loader = __webpack_require__(6035);
;// CONCATENATED MODULE: ./hooks/useScrollBlock.ts

var useScrollBlock = function useScrollBlock() {
  var safeDocument = document;
  var scrollBlocked = (0,react.useRef)(false);
  var html = safeDocument.documentElement;
  var body = safeDocument.body;

  var blockScroll = function blockScroll() {
    if (!body || !body.style || scrollBlocked.current) return;
    if (document === undefined) return;
    var scrollBarWidth = window.innerWidth - html.clientWidth;
    var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue('padding-right'), 10) || 0;
    html.style.position = 'relative';
    /* [1] */

    html.style.overflow = 'hidden';
    /* [2] */

    body.style.position = 'relative';
    /* [1] */

    body.style.overflow = 'hidden';
    /* [2] */

    body.style.paddingRight = "".concat(bodyPaddingRight + scrollBarWidth, "px");
    scrollBlocked.current = true;
  };

  var allowScroll = function allowScroll() {
    if (!body || !body.style || !scrollBlocked.current) return;
    html.style.position = '';
    html.style.overflow = '';
    body.style.position = '';
    body.style.overflow = '';
    body.style.paddingRight = '';
    scrollBlocked.current = false;
  };

  return {
    blockScroll: blockScroll,
    allowScroll: allowScroll
  };
};
;// CONCATENATED MODULE: ./components/verify-email/index.tsx
















function VerifyEmail() {
  var _user$data2, _user$data3, _error$response;

  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(selector/* authSelector */.a),
      user = _useAppSelector.user;

  var _useResendEmail = useResendEmail(),
      resend = _useResendEmail.resend,
      isError = _useResendEmail.isError,
      error = _useResendEmail.error,
      data = _useResendEmail.data,
      isLoading = _useResendEmail.isLoading;

  var _useScrollBlock = useScrollBlock(),
      allowScroll = _useScrollBlock.allowScroll,
      blockScroll = _useScrollBlock.blockScroll;

  var closeIsVerifyBox = (0,react.useCallback)(function () {
    dispatch((0,global.toggleIsVerifiedBox)());
  }, [dispatch]);
  (0,react.useEffect)(function () {
    blockScroll();
    return function () {
      allowScroll();
    };
  }, [allowScroll, blockScroll]);

  function onResendEmailClick() {
    var _user$data;

    // Disabling rules because this part will be deprecated

    /* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain */
    resend({
      email: (_user$data = user.data) === null || _user$data === void 0 ? void 0 : _user$data.email
    });
    /* eslint-enable */
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VerifyEmailWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Verify Account"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      className: "verify-header",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(container/* Container */.W, {
        size: "lg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "verify-header-logo",
          onClick: closeIsVerifyBox,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/static/logo-1.png",
            width: 25,
            height: 40
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "verify-header-logo-mobile",
          onClick: closeIsVerifyBox,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/static/logo-2.svg",
            width: 105,
            height: 25
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(VerifyEmailBoxWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "verify",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/static/icons/verify-email.svg",
          width: 100,
          height: 100
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(title/* default */.Z, {
          type: "mode3",
          className: "verify-title",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Verify your e-mail"
          }), " to finish signing up to Richr."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "verify-desc",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(common_text/* default */.Z, {
            type: "mode8",
            className: "verify-desc-1",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: (_user$data2 = user.data) === null || _user$data2 === void 0 ? void 0 : _user$data2.fullName
            }), " please confirm that ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: (_user$data3 = user.data) === null || _user$data3 === void 0 ? void 0 : _user$data3.email
            }), " is your email address by going to your inbox and verifying your email\n          address."]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
            type: "mode8",
            className: "verify-desc-2",
            children: "Sometimes emails go to spam or your junk mail folder, please\n          check there if you dont see an email from us."
          }), !data && !isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "verify-desc-resend",
            onClick: onResendEmailClick,
            type: "button",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
              type: "mode8",
              children: "Resend email"
            })
          }), isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(loader/* Loader */.a, {}), isError && /*#__PURE__*/(0,jsx_runtime.jsxs)(VerifyEmailError, {
            children: ["Next Available Time: ", error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.nextAvailableTime]
          }), data && data.success && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/static/icons/checkmarks.svg",
            width: 24,
            height: 24
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(common_text/* default */.Z, {
          className: "verify-bottom",
          type: "mode8",
          children: ["Need help? Ask at ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "mailto:hello@richr.com",
            children: "hello@richr.com"
          }), " or call ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "tel:+18449574247",
            children: "+1-844-957-4247"
          })]
        })]
      })
    })]
  });
}

/* harmony default export */ var verify_email = (/*#__PURE__*/(0,react.memo)(VerifyEmail));
;// CONCATENATED MODULE: ./components/header/HeaderAccount.tsx















function HeaderAccount() {
  var _useLogout = (0,useLogout/* useLogout */.a)(),
      logout = _useLogout.logout;

  var router = (0,next_router.useRouter)();
  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(selector/* userSelector */.n),
      data = _useAppSelector.data,
      jwt = _useAppSelector.jwt;

  var accountRef = (0,react.useRef)(null); // const { isOpen, toggle } = useToggle(accountRef);

  var _useAppSelector2 = (0,useRedux/* useAppSelector */.C)(globalSelector),
      isVerifiedBox = _useAppSelector2.isVerifiedBox;

  var handleViewMyProfile = (0,react.useCallback)(function () {
    if (data !== null && data !== void 0 && data.isVerified) {
      router.push({
        pathname: routes/* DASHBOARD_ROUTE */.zO
      });
    } else {
      dispatch((0,global.toggleIsVerifiedBox)());
    }
  }, [data === null || data === void 0 ? void 0 : data.isVerified, router, dispatch]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderAccountWrapper, {
      className: "account",
      ref: accountRef // onClick={toggle}
      ,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "account-avatar",
        onClick: handleViewMyProfile,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          type: "mode4",
          fw: "medium",
          children: data === null || data === void 0 ? void 0 : data.fullName[0]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "account-logout",
        onClick: logout,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          fw: "bold",
          children: "Log out"
        })
      })]
    }), jwt && !(data !== null && data !== void 0 && data.isVerified) && isVerifiedBox && /*#__PURE__*/(0,jsx_runtime.jsx)(verify_email, {})]
  });
}

/* harmony default export */ var header_HeaderAccount = (/*#__PURE__*/(0,react.memo)(HeaderAccount));
;// CONCATENATED MODULE: ./components/header/HeaderBottomBlock.tsx









function HeaderBottomBlock() {
  var _useTriggerFunnelytic = (0,useTriggerFunnelyticsEvent/* default */.Z)(),
      createEventTriggerer = _useTriggerFunnelytic.createEventTriggerer;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderBottomBlockWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      href: "tel:+18449574247",
      onClick: createEventTriggerer({
        eventName: constants/* GENERIC_EVENTS.CALL_EXPERT */._A.CALL_EXPERT,
        withPathname: true,
        ctaPosition: 'floating-mobile-cta'
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/static/icons/phone-green.svg",
        alt: "Phone Icon",
        priority: true,
        width: 24,
        height: 24
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
        fw: "medium",
        type: "mode9",
        children: "+1844-957-4247"
      })]
    })
  });
}

/* harmony default export */ var header_HeaderBottomBlock = (/*#__PURE__*/(0,react.memo)(HeaderBottomBlock));
;// CONCATENATED MODULE: ./components/header/index.tsx


 // @ts-expect-error (@tawk.to/tawk-messenger-react does not have ts support)





 // import Burger from "../common/Burger";















function Header(_ref) {
  var transparentHeader = _ref.transparentHeader;

  var _useWindow = (0,useWindow/* useWindow */.z)(),
      w = _useWindow.w;

  var _useTriggerFunnelytic = (0,useTriggerFunnelyticsEvent/* default */.Z)(),
      createEventTriggerer = _useTriggerFunnelytic.createEventTriggerer;

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(selector/* userSelector */.n),
      jwt = _useAppSelector.jwt;

  var dispatch = (0,useRedux/* useAppDispatch */.T)();
  var openMobileMenu = (0,react.useCallback)(function () {
    dispatch((0,global.toggleMobileNav)());
  }, [dispatch]);

  var _useWindowScroll = (0,useWindow/* useWindowScroll */.b)(),
      scrollTop = _useWindowScroll.scrollTop;

  var _useState = (0,react.useState)(false),
      whiteHeader = _useState[0],
      setWhiteHeader = _useState[1];

  (0,react.useEffect)(function () {
    if (scrollTop >= 100) {
      setWhiteHeader(true);
    } else {
      setWhiteHeader(false);
    }
  }, [scrollTop]);

  function getIconName() {
    if (whiteHeader || transparentHeader) {
      return 'burger-colored';
    }

    return 'burger';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderWrapper, {
      whiteHeader: whiteHeader,
      transparentHeader: transparentHeader,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(container/* Container */.W, {
        size: "xl",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderLogo, {
            className: "header-logo",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/static/".concat(!whiteHeader ? "logo-richr-new" : "logo-richr-new-colored", ".svg"),
              width: w <= 1280 ? 112 : 132,
              height: w <= 1280 ? 38 : 44,
              priority: true,
              quality: 100
            })
          })
        }), w > 1280 && /*#__PURE__*/(0,jsx_runtime.jsx)(header_HeaderNavigation, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderActions, {
          children: [w > 1280 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "tel:+18449574247",
              className: "header-phone",
              onClick: createEventTriggerer({
                eventName: constants/* GENERIC_EVENTS.CALL_EXPERT */._A.CALL_EXPERT,
                withPathname: true,
                ctaPosition: 'nav-bar'
              }),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                fw: "bold",
                children: "+1844-957-4247"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: routes/* HOME_VALUATION_ROUTE */.S0,
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "header-valuation",
                onClick: createEventTriggerer({
                  eventName: constants/* HOME_VALUATION_EVENTS.START */.eM.START,
                  withPathname: true,
                  ctaPosition: 'nav-bar'
                }),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
                  fw: "bold",
                  children: "Get My Free Home Valuation"
                })
              })
            }), jwt && /*#__PURE__*/(0,jsx_runtime.jsx)(header_HeaderAccount, {})]
          }), w <= 1280 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [jwt && /*#__PURE__*/(0,jsx_runtime.jsx)(header_HeaderAccount, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              onClick: openMobileMenu,
              className: "header-burger",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "/static/icons/".concat(getIconName(), ".svg"),
                width: 32,
                height: 32,
                alt: "Burger Icon"
              })
            })]
          })]
        })]
      }), w <= 1280 && /*#__PURE__*/(0,jsx_runtime.jsx)(header_HeaderNavigationMobile, {})]
    }), w <= 480 && /*#__PURE__*/(0,jsx_runtime.jsx)(header_HeaderBottomBlock, {}), w <= 480 && /*#__PURE__*/(0,jsx_runtime.jsx)(TawkMessenger, {
      propertyId: "5ec6e7c0c75cbf1769ee3345",
      widgetId: "default"
    })]
  });
}

/* harmony default export */ var header = (/*#__PURE__*/(0,react.memo)(Header));

/***/ }),

/***/ 97449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$U": function() { return /* binding */ HOME_PAGE_LINK; },
/* harmony export */   "Rh": function() { return /* binding */ FAQ_LINK; },
/* harmony export */   "SB": function() { return /* binding */ TERMS_AND_PRIVACY_LINK; },
/* harmony export */   "ar": function() { return /* binding */ MANIFESTO_LINK; },
/* harmony export */   "rI": function() { return /* binding */ BLOG_LINK; },
/* harmony export */   "xL": function() { return /* binding */ PRIVACY_LINK; }
/* harmony export */ });
/* unused harmony export RICHR_HOMES_LINK */
var HOME_PAGE_LINK = 'https://richr.com';
var BLOG_LINK = 'https://richr.com/blog';
var MANIFESTO_LINK = "".concat(BLOG_LINK, "/manifesto/");
var TERMS_AND_PRIVACY_LINK = "".concat(BLOG_LINK, "/terms-of-service/");
var PRIVACY_LINK = "".concat(BLOG_LINK, "/privacy-policy/");
var FAQ_LINK = "".concat(BLOG_LINK, "/faqs/");
var RICHR_HOMES_LINK = 'https://homes.richr.com/';

/***/ }),

/***/ 18070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dz": function() { return /* binding */ listingSelector; },
/* harmony export */   "ER": function() { return /* binding */ createListingSelector; },
/* harmony export */   "f2": function() { return /* binding */ updateListingSelector; },
/* harmony export */   "l2": function() { return /* binding */ createAdminListingSelector; },
/* harmony export */   "nF": function() { return /* binding */ deleteListingSelector; }
/* harmony export */ });
/* unused harmony export verifyListingTokenSelector */
var listingSelector = function listingSelector(state) {
  return state.listing;
};
var createListingSelector = function createListingSelector(state) {
  return state.listing.createListing;
};
var createAdminListingSelector = function createAdminListingSelector(state) {
  return state.listing.createAdminListing;
};
var updateListingSelector = function updateListingSelector(state) {
  return state.listing.updateListing;
};
var deleteListingSelector = function deleteListingSelector(state) {
  return state.listing.deleteListing;
};
var verifyListingTokenSelector = function verifyListingTokenSelector(state) {
  return state.listing.verifyListingToken;
};

/***/ }),

/***/ 29623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useLogout; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85945);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71624);
/* harmony import */ var store_slices_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43685);
/* harmony import */ var _useRedux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22152);






var useLogout = function useLogout() {
  var dispatch = (0,_useRedux__WEBPACK_IMPORTED_MODULE_4__/* .useAppDispatch */ .T)();
  var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var logout = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    dispatch((0,store_slices_auth__WEBPACK_IMPORTED_MODULE_3__.removeUser)());
    queryClient.removeQueries();

    if (router.pathname.includes(constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .QUESTIONAIRE_ROUTE */ .Mx) || router.pathname.includes(constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .DASHBOARD_ROUTE */ .zO)) {
      router.replace(constants_routes__WEBPACK_IMPORTED_MODULE_2__/* .SIGNIN_ROUTE */ .OQ);
    }
  }, [dispatch, queryClient, router]);
  return {
    logout: logout
  };
};

/***/ }),

/***/ 22152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

var useAppDispatch = function useAppDispatch() {
  return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;

/***/ }),

/***/ 16300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_A": function() { return /* binding */ GENERIC_EVENTS; },
/* harmony export */   "eM": function() { return /* binding */ HOME_VALUATION_EVENTS; },
/* harmony export */   "kX": function() { return /* binding */ LISTING_EVENTS; }
/* harmony export */ });
var LISTING_EVENTS = {
  START: 'start_listing',
  CREATE: 'create_listing',
  UPDATE_SELLER_DETAILS: 'update_listing_seller_details',
  CONTNIUE_LAST: 'continue_last_listing',
  DELETE_AND_START_NEW: 'delete_and_start_new_listing',
  CHECK_STATUS: 'check_listing_status',
  UPDATE_PROPERTY_TYPE: 'update_listing_property_type',
  UPDATE_PROPERTY_DETAILS: 'update_listing_property_details',
  UPDATE_PRICE_DETAILS: 'update_listing_price_details',
  ACCEPT_AGREEMENT: 'accept_listing_agreement',
  REQUEST_CALLBACK: 'request_listing_callback',
  SUBMIT: 'submit_listing',
  OPEN_CHATBOT: 'open_listing_chatbot'
};
var HOME_VALUATION_EVENTS = {
  START: 'start_home_valuation',
  SUBMIT: 'submit_valuation',
  SUBMIT_WITHOUT_AVM_DATA: 'submit_valuation_without_avm_data'
};
var GENERIC_EVENTS = {
  CALL_EXPERT: 'call_expert'
};

/***/ }),

/***/ 91974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var containers_listing_slice_selector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18070);
/* harmony import */ var hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22152);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16300);
/* provided dependency */ var process = __webpack_require__(83454);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var isAnalyticsDebugEnabled = process.env.NEXT_PUBLIC_ANALYTICS_DEBUG === 'true';

function useTriggerFunnelyticsEvent() {
  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      pathname = _useRouter.pathname;

  var _useAppSelector = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .C)(containers_listing_slice_selector__WEBPACK_IMPORTED_MODULE_5__/* .listingSelector */ .Dz),
      listingData = _useAppSelector.data;

  var _ref = listingData || {},
      seller = _ref.seller,
      address = _ref.address;

  function triggerEvent(_ref2) {
    var _funnelytics;

    var eventName = _ref2.eventName,
        data = _ref2.data,
        withPathname = _ref2.withPathname,
        ctaPosition = _ref2.ctaPosition;

    var eventData = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0,lodash__WEBPACK_IMPORTED_MODULE_1__.includes)((0,lodash__WEBPACK_IMPORTED_MODULE_1__.values)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LISTING_EVENTS */ .kX), eventName) && _objectSpread(_objectSpread({}, seller), address && {
      address: address
    })), withPathname && {
      pathname: pathname
    }), ctaPosition && {
      ctaPosition: ctaPosition
    }), data && data);

    if (isAnalyticsDebugEnabled) {
      // eslint-disable-next-line no-console
      console.log('Funnelytics event triggered', {
        eventName: eventName,
        eventData: eventData
      });
    }

    (_funnelytics = window.funnelytics) === null || _funnelytics === void 0 ? void 0 : _funnelytics.events.trigger(eventName, eventData);
  }

  function createEventTriggerer(_ref3) {
    var eventName = _ref3.eventName,
        callback = _ref3.callback,
        data = _ref3.data,
        withPathname = _ref3.withPathname,
        ctaPosition = _ref3.ctaPosition;
    return function ctaClickHandler() {
      triggerEvent({
        eventName: eventName,
        data: data,
        withPathname: withPathname,
        ctaPosition: ctaPosition
      });

      if ((0,lodash__WEBPACK_IMPORTED_MODULE_1__.isFunction)(callback)) {
        callback();
      }
    };
  }

  return {
    triggerEvent: triggerEvent,
    createEventTriggerer: createEventTriggerer
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useTriggerFunnelyticsEvent);

/***/ }),

/***/ 1284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useWindowScroll; },
/* harmony export */   "z": function() { return /* binding */ useWindow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useWindow = function useWindow() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(window.innerWidth),
      w = _useState[0],
      setW = _useState[1];

  var listener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    var window = e.currentTarget;
    setW(window.innerWidth);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('resize', listener);
    return function () {
      window.removeEventListener('resize', listener);
    };
  }, [listener]);
  return {
    w: w
  };
};
var useWindowScroll = function useWindowScroll() {
  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(window.scrollY),
      scrollTop = _useState2[0],
      setScrollTop = _useState2[1];

  var listener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (e) {
    var window = e.currentTarget;
    setScrollTop(window.scrollY);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('scroll', listener);
    return function () {
      window.removeEventListener('scroll', listener);
    };
  }, [listener]);
  return {
    scrollTop: scrollTop
  };
};

/***/ }),

/***/ 89537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ authSelector; },
/* harmony export */   "n": function() { return /* binding */ userSelector; }
/* harmony export */ });
var authSelector = function authSelector(state) {
  return state.authSlice;
};
var userSelector = function userSelector(state) {
  return state.authSlice.user;
};

/***/ }),

/***/ 54610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U1": function() { return /* binding */ fade; },
/* harmony export */   "wo": function() { return /* binding */ collapse; }
/* harmony export */ });
/* unused harmony export toLeft */
var toLeft = {
  hidden: {
    x: '100%',
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.3
    }
  },
  exit: {
    x: '100%',
    opacity: 0,
    transition: {
      duration: 0.3
    }
  }
};
var fade = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.2
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }
};
var collapse = {
  hidden: {
    opacity: 0,
    height: 0
  },
  visible: {
    opacity: 1,
    height: 'auto',
    transition: {
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.3
    }
  }
};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ })

}]);